import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import DashboardNavbarComponent from './DashboardNavbar.component';
import adminsApi from "../../configs/apis/admins";
import ProfileDialog from "../ProfileDialog";
import { setAccessRight } from "../../configs/redux/session/session.slice";

export default function DashboardNavbarContainer({
  onDrawerToggle,
  name,
  roleName,
}) {
  const [isProfileDialogOpen, setProfileDialogOpen] = useState(false);

  const onProfileDialogOpen = () => {
    setProfileDialogOpen(true);
  };

  const onProfileDialogClose = () => {
    setProfileDialogOpen(false);
  };

  const handlePasswordReset = (value) => {
    adminsApi.resetPassword(value).then((response) => {
      setProfileDialogOpen(false);
    });
  };

  return (
    <>
      <DashboardNavbarComponent
        onDrawerToggle={onDrawerToggle}
        name={name}
        roleName={roleName}
        onProfileDialogOpen={onProfileDialogOpen}
      />
      <ProfileDialog
        open={isProfileDialogOpen}
        handleClose={onProfileDialogClose}
        handleSubmit={handlePasswordReset}
      />
    </>
  );
}
